import React from "react";
import "./FindCarSection.css";

const FindCarSection = () => {
  return (
    <section class="find-car-section1">
      <div class="container1">
        {/* Text Content */}
        <div class="text-content1">
          <h2>How to Buy a Vehicle at Auto Motor Auctions</h2>
          <h6>Welcome to Auto Motor Auctions! </h6>
          <p>
          If you're looking to purchase your next vehicle at a fraction of the retail price, you've come to the right place. We give you dealer-level access to a wide variety of cars, trucks, SUVs, and more at competitive prices. Whether you're a first-time buyer or a seasoned auction enthusiast, we make the process simple and transparent. 
          </p>
          <p>
          Here's a step-by-step guide on how to buy a vehicle from Auto Motor Auctions.

          </p>

          {/* Call-to-Action Box */}
          {/* <div class="cta-box1">
            <div class="cta-icon1">
              <div class="icon-circle1">
                <i class="icon-user"></i>
              </div>
            </div>
            <div class="cta-text1">
              <h3>Get Full Access Now</h3>
              <p>
                To start bidding and buying used cars online, you’ll have to
                register with AutoBidMaster.
              </p>
              <button class="cta-button1">REGISTER NOW</button>
            </div>
          </div> */}
        </div>

        {/* Video Embed */}
        {/* <div class="video-content1">
          <iframe
            src="https://www.youtube.com/embed/dummy-video-id"
            title="How do I Find a Car?"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div> */}
      </div>
    </section>
  );
};

export default FindCarSection;
